import { forwardRef, HTMLAttributes, ReactNode } from 'react';
import { cn } from './cn';

export type BadgeTone = 'neutral' | 'action' | 'pro' | 'success' | 'danger' | 'warning';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  children: ReactNode;
}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { tone = 'neutral', className, children, ...rest },
  ref
) {
  return (
    <span
      ref={ref}
      data-tss-ui=""
      data-tone={tone}
      className={cn('tss-badge', className)}
      {...rest}
    >
      {children}
    </span>
  );
});
